import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import React, { useState } from "react";
import { FullScreenModal } from "./FullScreenModal";

type Props = {
  title?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  previousRoute?: string;
};

export const RouteFullScreenModal = ({
  title,
  actions,
  children,
  previousRoute = "..",
}: Props) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [fromPath, setFromPath] = useState(previousRoute);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(true);

    return () => {
      setIsOpen(false);
    };
  }, []);

  useEffect(() => {
    const from = location.state?.from;

    if (!from) {
      return;
    }

    setFromPath(from);
  }, [location]);

  const closeModal = () => {
    document.body.style.pointerEvents = "auto";
    navigate(fromPath, { replace: true });
  };

  return (
    <FullScreenModal
      isOpen={isOpen}
      onClose={closeModal}
      header={title}
      headerActionButtons={actions}
    >
      {children}
    </FullScreenModal>
  );
};
